export const Regional = {
  ssp: 'SSP',
  cnn: 'CNN'
};

export type RegionalOptions = keyof typeof Regional;
